/**
 * Page de création d'une garantie (partagé)
 * - Utilisateurs internes : Choix entre Mode Assistant et Mode Preset
 * - Utilisateurs externes : Toujours Mode Assistant
 */

import { useState } from 'react';
import { useAuth } from '@/hooks/auth/useAuth';
import { WizardContainer } from '@/features/warranties/components/WizardContainer';

interface WarrantyCreatePageProps {
  onCreated?: (warrantyUuid: string) => void;
  societyId?: string;
  /** Mode embarqué dans un onglet (stepper/footer sticky au lieu de fixed) */
  embedded?: boolean;
}

export const WarrantyCreatePage = ({ onCreated, societyId, embedded }: WarrantyCreatePageProps) => {
  const { user } = useAuth();
  const [formMode, setFormMode] = useState<'wizard' | 'preset'>('wizard');

  // Utilisateurs internes → Choix entre wizard et preset
  if (user?.type === 'INTERNAL') {
    return (
      <WizardContainer formMode={formMode} onModeToggle={setFormMode} onCreated={onCreated} societyId={societyId} embedded={embedded} />
    );
  }

  // Utilisateurs externes → Toujours wizard (pas de toggle)
  return <WizardContainer onCreated={onCreated} societyId={societyId} embedded={embedded} />;
};
